import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'tooltipMessage'
})

export class TooltipMessagePipe implements PipeTransform {
    transform(message: string, delimiter: string): string | string[] {
      let tooltipData: string = '';
      const NEW_LINE_BULLET_POINT_ENTITIES: string = '&#10;&#8226;';

      if (!message.includes(delimiter)) {
          return message;
      }

      const ERR_REASON_LIST: string[] =  message.split(delimiter);

      ERR_REASON_LIST.forEach(reason => {
          reason = reason.trim();
          tooltipData = `${tooltipData}${NEW_LINE_BULLET_POINT_ENTITIES} ${reason}`;
      });

      const parser = new DOMParser();
      const decodedTooltipData = parser.parseFromString(tooltipData, 'text/html').body.textContent || ERR_REASON_LIST;
      
      return decodedTooltipData;
    }
}
